import { render, staticRenderFns } from "./Promos.vue?vue&type=template&id=b44c54b6&scoped=true"
import script from "./Promos.vue?vue&type=script&lang=js"
export * from "./Promos.vue?vue&type=script&lang=js"
import style0 from "./Promos.vue?vue&type=style&index=0&id=b44c54b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44c54b6",
  null
  
)

export default component.exports